export default "__VITE_ASSET__96fd0c7b__"